import Phaser from 'phaser';
import { ATLAS, directions, dogNames, characterFrames, animationKey, type CharacterState } from './SpriteExtractionConfig';
export class CharacterAnimationManager {
  static register(scene: Phaser.Scene): void {
    for (const character of ['cat', 'penguin', 'walker', ...Object.keys(dogNames), ...Object.keys(dogNames).flatMap(name => [`penguin-${name}`, `walker-${name}`])]) {
      for (const state of ['idle', 'walk', 'place-bomb', 'death', 'victory'] as CharacterState[]) {
        for (const direction of directions) {
          const key = animationKey(character, state, direction);
          if (!scene.anims.exists(key)) scene.anims.create({ key, frames: characterFrames(character, state, direction).frames.map(frame => ({ key: character.startsWith('penguin') ? 'penguin' : character.startsWith('walker') ? 'walker' : ATLAS, frame })), frameRate: state === 'idle' ? 2 : 10, repeat: state === 'walk' || state === 'idle' ? -1 : 0 });
        }
      }
    }
  }
}
